<template>
  <div
    :class="[
      $options.name,
      'tw:hidden tw:sm:flex tw:w-full tw:py-4 tw:px-4 tw:justify-center tw:items-center tw:gap-4 tw:border-b tw:border-default-200 tw:h-14',
      isDev ? 'tw:bg-default-000' : 'tw:bg-branding-000',
    ]"
  >
    <div class="tw:me-auto tw:w-full">
      <MainLayoutSearchBar />
    </div>

    <EngagementRateStatus v-if="isDev && isPaying" />

    <PackageManagerStatus
      :channel-type-id="CHANNEL_TYPE.SMS"
      icon="fa-light fa-message-sms"
      @open-package-manager="openSMS"
    />
    <PackageManagerStatus
      :channel-type-id="CHANNEL_TYPE.WHATSAPP"
      icon="fa-brands fa-whatsapp"
      @open-package-manager="openWhatsapp"
    />

    <EdroneButtonIcon
      :tooltip="trans._menu.topBar.buttons.canny"
      type="plain"
      unique-id="main-top-bar__canny-button"
      @click="handleCannyHelp"
    >
      <FontAwesomeIcon class="tw:text-2xl" icon="fa-light fa-lightbulb-exclamation" />
    </EdroneButtonIcon>
    <EdroneButtonIcon
      :tooltip="trans._menu.topBar.buttons.help"
      type="plain"
      unique-id="main-top-bar__help-button"
      @click="handleClickHelp"
    >
      <FontAwesomeIcon class="tw:text-2xl" icon="fa-light fa-circle-question" />
    </EdroneButtonIcon>
    <EdroneButtonIcon
      :tooltip="trans._menu.topBar.buttons.news"
      class="beamerTrigger"
      type="plain"
      unique-id="main-top-bar__beamer-button"
    >
      <FontAwesomeIcon class="tw:text-2xl" icon="fa-light fa-megaphone" />
    </EdroneButtonIcon>
    <NotificationsMenu />
  </div>
</template>

<script lang="ts" setup>
import EdroneButtonIcon from "edrone-components/EdroneButtonIcon.vue";
import NotificationsMenu from "vue-app/components/NotificationsMenu/NotificationsMenu.vue";
import MainLayoutSearchBar from "./MainLayoutSearchBar.vue";
import PackageManagerStatus from "vue-app/components/PackageManager/PackageManagerStatus.vue";
import EngagementRateStatus from "vue-app/components/EngagementRateStatus/EngagementRateStatus.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { CHANNEL_TYPE } from "vue-app/types/enums";
import { usePackageManager } from "vue-app/composables/usePackageManager";

const { openWhatsapp, openSMS } = usePackageManager();

function handleClickHelp() {
  window.open(window._trans["support_link"], "_blank");
}

function handleCannyHelp() {
  window.open("https://edrone.canny.io/", "_blank");
}

const isDev = window.EDRONE_CONTEXT.user.isDev;
const isPaying = window.EDRONE_CONTEXT.tracker.isPaying;
const trans = window._trans;
</script>
